<template>
    <div class="city_desc_swiper">
        <swiper ref="swiper" class="pc" :options="options">
            <template v-for="(item, index) in data">
                <swiper-slide :key="index">
                    <div class="title">{{item.project_name}}</div>
                    <div class="desc" v-html="textToHtml(item.project_desc)"></div>
                </swiper-slide>
            </template>
        </swiper>
        <swiper ref="mobileSwiper" class="mobile" :options="mobileOptions">
            <template v-for="(item, index) in mobileData">
                <swiper-slide :key="index">
                    <div class="cover" :style="`background-image: url(${item.web_image})`"></div>
                    <div class="title">{{item.project_name}}</div>
                </swiper-slide>
            </template>
        </swiper>
        <div class="swiper-button-prev pc" slot="button-prev"></div>
        <div class="swiper-button-next pc" slot="button-next"></div>
        <div class="swiper-button-prev mobile" slot="button-prev"></div>
        <div class="swiper-button-next mobile" slot="button-next"></div>
    </div>
</template>

<script>
import { swiper, swiperSlide, directive, navigation } from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css'
import lineBreaks from '../utils/lineBreaks';
export default {
    name: "CityDescSwiper",
    props: [ 'data', 'mobileData' ],
    data() {
        return {
            options: {
                resistanceRatio: 0,
                navigation: {
                    prevEl: '.city_desc_swiper .swiper-button-prev.pc',
                    nextEl: '.city_desc_swiper .swiper-button-next.pc',
                },
                observer: true,
                observeParents: true,
            },
            mobileOptions: {
                slidesPerView: 'auto',
                resistanceRatio: 0,
                navigation: {
                    prevEl: '.city_desc_swiper .swiper-button-prev.mobile',
                    nextEl: '.city_desc_swiper .swiper-button-next.mobile',
                },
                observer: true,
                observeParents: true,
                spaceBetween: '18.57%',
            },
        };
    },
    computed: {
        swiper() {
            return this.$refs.swiper.$swiper
        },
        mobileSwiper() {
            return this.$refs.mobileSwiper.$swiper
        },
        textToHtml: lineBreaks.textToHtml
    },
    components: {
        swiper,
        swiperSlide,
        
    },
    mounted() {
    },
    destroyed() {},
    watch: {
        data(){
            // 数据变动后，轮播图切换到第一个
            this.swiper.slideTo(0, 0);
            this.mobileSwiper.slideTo(0, 0);
        }
    },
    methods: {},
};
</script>

<style scoped lang="scss">
.city_desc_swiper{
    position: relative;
    .mobile{
        display: none;
    }
    .swiper-slide{
        text-align: center;
        .title{
            font-size: .26rem;
            font-weight: bold;
            margin-bottom: .2rem;
        }
    }
    .swiper-button-prev,
    .swiper-button-next{
        width: .24rem;
        height: .3rem;
        background: no-repeat 0/100%;
        margin-top: -.15rem;
        &::after{
            display: none;
        }
        &.swiper-button-disabled{
            opacity: 0;
        }
    }
    .swiper-button-prev{
        left: -.75rem;
        background-image: url('~@/assets/images/icon_arrow_prev.svg');
    }
    .swiper-button-next{
        right: -.75rem;
        background-image: url('~@/assets/images/icon_arrow_next.svg');
    }
    @media only screen and (max-width: 1200px) {
        padding: 0 1.6rem;
        overflow: hidden;
        .pc{
            display: none;
        }
        .mobile{
            display: block;
            overflow: visible;
        }
        .swiper-slide{
            width: 3.77rem;
            .cover{
                width: 100%;
                height: 3.77rem;
                background: no-repeat center/cover;
                border-radius: .2rem;
                margin-bottom: .5rem;
            }
            .title{
                font-weight: normal;
                font-size: .36rem;
            }
        }
        .swiper-button-prev,
        .swiper-button-next{
            width: .64rem;
            height: .82rem;
            margin-top: 0;
            top: 1.47rem;
        }
        .swiper-button-prev{
            left: .35rem;
        }
        .swiper-button-next{
            right: .35rem;
        }
    }
}
</style>